import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
}

const AvatarLargeDefault: React.SFC<IProps> = (props) => {

    const { ...ImgProps } = props;

    return (<img {...ImgProps} />)

};

const AvatarLarge = styled(AvatarLargeDefault)`
    width: 180px;
    height: 180px;
    border-radius: 50%; 
    object-fit: cover;
`;

export default AvatarLarge;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/avatar/avatar_large.tsx